module.exports = __webpack_public_path__ + "img/zu6827.2621c072.svg";